<div
  class="geo-location-card"
  [class.geo-location-card--filled]="hasLocation"
  [class.geo-location-card--disabled]="disabled"
  [class.geo-location-card--plain]="variant === 'plain'">
  <div class="geo-location-preview" [class.geo-location-preview--clickable]="!disabled" (click)="openMap()">
    <ng-container *ngIf="hasLocation; else emptyPreview">
      <div #previewMapContainer class="geo-location-preview-map"></div>
      <div class="geo-location-map-error" *ngIf="previewMapLoadError">
        Mapa no disponible
      </div>
    </ng-container>

    <ng-template #emptyPreview>
      <div class="geo-location-empty">
        <mat-icon>add_location_alt</mat-icon>
      </div>
    </ng-template>
  </div>

  <div class="geo-location-footer" [class.geo-location-footer--action-only]="!showSummary">
    <div class="geo-location-summary" *ngIf="showSummary">
      <span class="geo-location-label">{{ label }}</span>
      <span class="geo-location-value">{{ locationSummary }}</span>
    </div>
    <button mat-stroked-button color="primary" type="button" (click)="openMap()" [disabled]="disabled">
      {{ actionLabel }}
    </button>
  </div>
</div>

<div class="geo-location-overlay" #overlayRoot [class.geo-location-overlay--hidden]="!mapOpen" (click)="$event.target === $event.currentTarget && closeMap()">
  <div class="geo-location-modal">
    <div class="geo-location-modal-head">
      <h3><mat-icon>place</mat-icon> Ubicacion</h3>
      <button mat-icon-button type="button" (click)="closeMap()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="geo-location-map-shell">
      <div class="geo-location-toolbar">
        <div class="geo-location-search">
          <mat-icon>search</mat-icon>
          <input
            type="text"
            placeholder="Buscar una dirección, ciudad, código postal o coordenadas"
            [(ngModel)]="searchText"
            [ngModelOptions]="{ standalone: true }"
            (keydown.enter)="searchAddress()"
          />
        </div>
        <button class="geo-location-locate-btn" type="button" [disabled]="searching" (click)="useMyLocation()">
          <mat-icon>my_location</mat-icon>
          <span>Usar mi ubicacion</span>
        </button>
      </div>

      <div #mapContainer class="geo-location-map"></div>
      <div class="geo-location-map-error geo-location-map-error--modal" *ngIf="mapLoadError">
        Mapa no disponible
      </div>
    </div>

    <div class="geo-location-modal-foot">
      <span class="geo-location-hint" [class.geo-location-hint--error]="statusMessage">
        {{ statusMessage || (selectedLocationSummary + ' - Click en el mapa o arrastra el marcador') }}
      </span>

      <div class="geo-location-actions">
        <button mat-stroked-button type="button" (click)="closeMap()">Cancelar</button>
        <button mat-raised-button color="primary" type="button" (click)="save()">Aplicar</button>
      </div>
    </div>
  </div>
</div>
